import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEqual from 'date-fns/isEqual';
import closestIndexTo from 'date-fns/closestIndexTo';
import isValid from 'date-fns/isValid';
import { absoluteUrl } from '../../utils/url';
import { getImageByWidth } from '../../utils/api';
import { updateMetaData } from '../../actions/metaDataActions';
import Swipeable from 'react-swipeable';
import TimelineSlide from './TimelineSlide';


class Slides extends Component {
  constructor (props) {
    super(props);
    this.handleControllerDateChange = this.handleControllerDateChange.bind(this);
    this.handleSwipeLeft = this.handleSwipeLeft.bind(this);
    this.handleSwipeRight = this.handleSwipeRight.bind(this);
    this.setMetaData = this.setMetaData.bind(this);
  }

  componentDidMount () {
    this.setMetaData();
  }

  componentDidUpdate (prevProps, prevState) {
    const { controllerDate, activeSlideIndex } = this.props;
    if (controllerDate && !isEqual(controllerDate, prevProps.controllerDate)) {
      this.handleControllerDateChange();
    }
    if (activeSlideIndex !== prevProps.activeSlideIndex) {
      this.setMetaData();
    }
  }

  componentWillUnmount () {
    this.setMetaData(true);
  }

  getBaseUrl () {
    const { match, activeEra } = this.props;
    return `${match.url}${activeEra ? '/' + activeEra : ''}`;
  }

  handleSwipeLeft () {
    const { history, activeSlideIndex, slideData: { slides } } = this.props;
    const urlSlideIndex = activeSlideIndex + 1;
    const nextUrl = urlSlideIndex < slides.length ? `${this.getBaseUrl()}/${urlSlideIndex + 1}` : null;

    // Navigate to next slide
    if (nextUrl) {
      history.push(nextUrl);
    }
  }

  handleSwipeRight () {
    const { history, activeSlideIndex } = this.props;
    const urlSlideIndex = activeSlideIndex + 1;
    const prevUrl = urlSlideIndex > 1 ? `${this.getBaseUrl()}/${urlSlideIndex - 1}` : null;

    // Navigate to previous slide
    if (prevUrl) {
      history.push(prevUrl);
    }
  }

  handleControllerDateChange () {
    const { history, controllerDate, slideData: { slides } } = this.props;
    const datesArray = slides.map(slide => slide.date).filter(date => isValid(date));
    const closestSlideIndex = closestIndexTo(controllerDate, datesArray);
    const url = `${this.getBaseUrl()}/${closestSlideIndex + 1}`;
    history.push(url);
  }

  setMetaData (reset = false) {
    const { actions, match, activeEra, activeSlideIndex, slideData: { slides } } = this.props;
    const eraPart = activeEra ? `/${activeEra}` : '';
    const url = absoluteUrl(`${match.url}${eraPart}/${activeSlideIndex + 1}`);
    const slide = slides[activeSlideIndex];
    let imageUrl = null;
    if (slide.mediaSource === 'media_library' && slide.media && slide.media.type === 'image') {
      const image = getImageByWidth(slide.media.versions, 900);
      imageUrl = image ? absoluteUrl(image.url) : null;
    }
    actions.updateMetaData({
      page: reset ? {} : {
        url,
        title: `${slide.dateFormatted}: ${slide.headline}`,
        description: slide.description,
        ...(imageUrl ? { image: imageUrl } : {}),
      },
    });
  }

  renderSlides () {
    const { activeSlideIndex, slideData: { slides } } = this.props;
    return slides.map((slide, i) => {
      const shouldPreload = i >= activeSlideIndex - 3 && i <= activeSlideIndex + 3;
      const isCurrent = i === activeSlideIndex;
      return <TimelineSlide key={i} {...slide} shouldPreload={shouldPreload} isCurrent={isCurrent} />;
    });
  }

  render () {
    const { containerWidth, activeSlideIndex, slideData: { slides } } = this.props;
    const left = activeSlideIndex < slides.length ? -(containerWidth * activeSlideIndex) : 0;

    return (
      <Swipeable className="timeline-slides-container" onSwipedLeft={this.handleSwipeLeft} onSwipedRight={this.handleSwipeRight}>
        <div className="timeline-slides" style={{ left }}>
          {this.renderSlides()}
        </div>
      </Swipeable>
    );
  }
}

Slides.propTypes = {
  titleId: PropTypes.string.isRequired,
  containerWidth: PropTypes.number,
};

const mapStateToProps = ({ titles }, ownProps) => ({
  ...titles[ownProps.titleId],
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateMetaData }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Slides));



// WEBPACK FOOTER //
// ./src/components/Timeline/Slides.js